module.exports = __webpack_public_path__ + "img/uk.32c5e88f.png";